import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
/**
 * Resolves the DOM `<td>` for the active selection's fill-handle cell so the
 * floating action menu can anchor to it.
 *
 * Uses a backoff retry for the initial find (the cell may not be in the DOM on
 * the first tick under virtualization), then a rAF-throttled scroll listener
 * that re-queries on each scroll event. Under full virtualization, scrolling
 * the cell out of view unmounts its `<td>` (re-query returns null → menu
 * hides) and scrolling back mounts a new node (re-query returns the new node →
 * menu returns).
 */
export const useFillHandleAnchorElement = t0 => {
  var _coord$rowIndex, _coord$columnIndex;
  const $ = _c(16);
  const {
    coord,
    scrollContainerElementRef,
    widths
  } = t0;
  const [anchorElement, setAnchorElement] = useState(null);
  const rowIndex = (_coord$rowIndex = coord === null || coord === void 0 ? void 0 : coord.rowIndex) !== null && _coord$rowIndex !== void 0 ? _coord$rowIndex : null;
  const columnIndex = (_coord$columnIndex = coord === null || coord === void 0 ? void 0 : coord.columnIndex) !== null && _coord$columnIndex !== void 0 ? _coord$columnIndex : null;
  let t1;
  if ($[0] !== columnIndex || $[1] !== rowIndex || $[2] !== scrollContainerElementRef) {
    t1 = () => {
      const startedAt = Date.now();
      let nextDelayMs = 0;
      let timeoutId;
      const attempt = () => {
        const scrollContainer = scrollContainerElementRef.current;
        if (rowIndex === null || columnIndex === null || !scrollContainer) {
          setAnchorElement(null);
          return;
        }
        const found = scrollContainer.querySelector(`[data-column-index="${columnIndex}"][data-fdt-row-index="${rowIndex}"]`);
        if (found) {
          setAnchorElement(found);
          return;
        }
        if (Date.now() - startedAt >= 2000) {
          setAnchorElement(null);
          return;
        }
        nextDelayMs = nextDelayMs === 0 ? 50 : Math.min(nextDelayMs * 2, 500);
        timeoutId = setTimeout(attempt, nextDelayMs);
      };
      timeoutId = setTimeout(attempt, 0);
      return () => clearTimeout(timeoutId);
    };
    $[0] = columnIndex;
    $[1] = rowIndex;
    $[2] = scrollContainerElementRef;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== columnIndex || $[5] !== rowIndex || $[6] !== scrollContainerElementRef || $[7] !== widths) {
    t2 = [rowIndex, columnIndex, widths, scrollContainerElementRef];
    $[4] = columnIndex;
    $[5] = rowIndex;
    $[6] = scrollContainerElementRef;
    $[7] = widths;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[9] !== columnIndex || $[10] !== rowIndex || $[11] !== scrollContainerElementRef) {
    t3 = () => {
      const scrollContainer_0 = scrollContainerElementRef.current;
      if (!scrollContainer_0 || rowIndex === null || columnIndex === null) {
        return;
      }
      let rafId = null;
      const handleScroll = () => {
        if (rafId !== null) {
          return;
        }
        rafId = requestAnimationFrame(() => {
          rafId = null;
          const found_0 = scrollContainer_0.querySelector(`[data-column-index="${columnIndex}"][data-fdt-row-index="${rowIndex}"]`);
          setAnchorElement(found_0 !== null && found_0 !== void 0 ? found_0 : null);
        });
      };
      scrollContainer_0.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => {
        scrollContainer_0.removeEventListener("scroll", handleScroll);
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
        }
      };
    };
    t4 = [rowIndex, columnIndex, scrollContainerElementRef];
    $[9] = columnIndex;
    $[10] = rowIndex;
    $[11] = scrollContainerElementRef;
    $[12] = t3;
    $[13] = t4;
  } else {
    t3 = $[12];
    t4 = $[13];
  }
  useEffect(t3, t4);
  let t5;
  if ($[14] !== anchorElement) {
    t5 = {
      anchorElement
    };
    $[14] = anchorElement;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};